import { Check, Flame } from 'lucide-react';

export default function CorrectAnswer({ points, totalScore, streak, questionNumber, totalQuestions }) {
  return (
    <div className="relative flex h-screen w-full flex-col bg-mp-lime font-body overflow-hidden">
      {/* Confetti decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <span className="absolute top-[8%] left-[10%] w-3 h-3 bg-mp-magenta rounded-sm rotate-[20deg] opacity-85" />
        <span className="absolute top-[14%] right-[15%] w-3 h-3 bg-mp-teal rounded-sm -rotate-[12deg] opacity-85" />
        <span className="absolute top-[28%] left-[8%] w-3 h-3 bg-mp-fox-rust rounded-sm opacity-85" />
        <span className="absolute top-[58%] right-[10%] w-3 h-3 bg-mp-darkgreen rounded-sm rotate-[40deg] opacity-85" />
        <span className="absolute top-[78%] left-[15%] w-3 h-3 bg-mp-magenta rounded-sm -rotate-[20deg] opacity-85" />
        <span className="absolute top-[86%] right-[20%] w-3 h-3 bg-mp-teal rounded-sm rotate-[15deg] opacity-85" />
        <span className="absolute top-[22%] left-[40%] w-2 h-2 bg-mp-darkgreen rounded-full opacity-85" />
        <span className="absolute top-[68%] left-[55%] w-2 h-2 bg-mp-fox-rust rounded-full opacity-85" />
      </div>

      {/* Header */}
      <header className="relative z-10 flex items-center justify-between p-6">
        <div className="inline-flex items-center bg-white/40 backdrop-blur-md rounded-full px-4 py-2 border border-mp-darkgreen/10">
          <span className="font-display text-mp-darkgreen text-[13px]">
            Spørsmål {questionNumber} av {totalQuestions}
          </span>
        </div>
        <div className="w-10" />
      </header>

      {/* Center */}
      <main className="relative z-10 flex flex-1 flex-col items-center justify-center text-center px-6 -mt-8">
        <div className="w-[120px] h-[120px] rounded-full bg-mp-darkgreen flex items-center justify-center mb-5 shadow-mp-3">
          <Check size={64} strokeWidth={3} className="text-mp-lime" />
        </div>
        <h1 className="font-display text-mp-darkgreen text-[56px] leading-none -tracking-[0.02em] mb-3">
          Riktig!
        </h1>
        <p className="font-display text-mp-darkgreen/70 text-lg mb-6">Heilt rett!</p>

        {/* Score */}
        <div className="inline-flex items-center gap-3 bg-mp-darkgreen text-mp-lime rounded-full px-5 py-2.5 mb-3">
          <span className="font-display text-[28px] leading-none">+ {points}</span>
          <span className="font-display text-[12px] uppercase tracking-[0.18em] opacity-80">poeng</span>
        </div>

        <p className="font-body text-mp-darkgreen/85 max-w-[260px]">
          Totalpoeng:{' '}
          <strong className="text-mp-darkgreen">{totalScore?.toLocaleString() || 0}</strong>
        </p>

        {/* Streak banner */}
        {streak > 1 && (
          <div className="mt-4 inline-flex items-center gap-1.5 bg-mp-fox-rust/15 text-mp-fox-rust rounded-full px-4 py-1.5 font-display text-[13px]">
            <Flame size={14} />
            <span>{streak} på rad!</span>
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="relative z-10 w-full pb-10">
        <div className="flex flex-col items-center gap-2.5">
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full bg-mp-darkgreen animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 rounded-full bg-mp-darkgreen animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 rounded-full bg-mp-darkgreen animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
          <p className="font-display text-mp-darkgreen/70 text-[11px] uppercase tracking-[0.18em]">
            Ventar på verten …
          </p>
        </div>
      </footer>
    </div>
  );
}
